import { Component, OnInit } from "@angular/core";
import {CurrencyPipe, NgForOf, NgIf} from "@angular/common";
import { FormBuilder, FormGroup, FormArray, ReactiveFormsModule, Validators, FormControl, FormsModule, ValidatorFn, ValidationErrors, AbstractControl } from "@angular/forms";
import { Dimensions, ImageCroppedEvent, ImageCropperModule } from "ngx-image-cropper";
import { DocumentsService } from "src/app/services/document.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { UploadService } from "src/app/services/upload.service";
import { UtilsService } from "src/app/services/utils.service";
import { RouterModule } from '@angular/router'; // Asegúrate de importar esto
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: "app-programas",
  standalone: true,
  imports: [NgForOf, ReactiveFormsModule, NgIf, ImageCropperModule, FormsModule, RouterModule, CurrencyPipe],
  templateUrl: "./programas.component.html",
  styleUrl: "./programas.component.css",
})
export class ProgramasComponent implements OnInit {
  userInfo: any;

  // BOOLEAN
  loading: boolean = false;
  editing: boolean = false;
  
  // FORM
  formPrograma: FormGroup;
  opcionesCuestionario: string[] = [
    'Objetivos',
    'Salud',
    'Ejercicio',
    'Alimentación',
    'Suplementos',
    'Comentarios'
  ];
  opcionesEquipoGeneral: string[] = [
    'Artículos de casa',
    'Depende del tipo de rutina solicitada',
    'Equipo básico de gimnasio',
    'Gimnasio completo',
    'Ninguno',
    'No es indispensable, pero ayudaría'
  ];
  opcionesEquipoEspecifico: string[] = [
    'Banca Plana',
    'Bancas',
    'Barra alta para colgarse',
    'Barras y discos de pesas',
    'Ligas',
    'Mancuernas',
    'Pelota de ejercicio',
    'Pelota medicinal',
    'pesas rusas',
    'Rack de sentadillas'
  ];

  // DATA
  userData: any;
  entrenadores: any = [];
  listaProgramas: any = [];
  selectedProgram: any;

  // FILTERS
  filters: any = {
    entrenador: "",
    tipo: ""
  };

  // IMAGES VARIABLES
  imageChangedEvent: any = "";
  croppedImage: any = "";
  showCropper = false;
  bolCroppedImg = false;
  selectedFile: File | null = null;
  rawFile: any;
  previewUrl: string | ArrayBuffer | null = null;

  constructor(
    private fb: FormBuilder,
    private documentService: DocumentsService,
    private uploadService: UploadService,
    private utilsService: UtilsService
  ){
    this.userData = JSON.parse(localStorage.getItem("userData"));

    this.formPrograma = this.fb.group(
      {
        nombre: ["", Validators.required],
        tipo: ["", Validators.required],
        opcional: [""],
        entrenador: ["", Validators.required],
        descCorta: [""],
        descLarga: [""],
        cantPeriodos: ["0", Validators.required],
        cantSemanas: ["0", Validators.required],
        planEjercicios: [false],
        planAlimentacion: [false],
        precioFinal: ["", Validators.required],
        asesoria: [false],
        // CHECKBOX WITH AN ARRAY OF CHECKBOXES THAT AT LEAST ONE MUST BE CHECKED
        equipoGeneral: this.fb.array([]),
        equipoEspecifico: this.fb.array([]),
        pagoNombre: [""],
        pagoBanco: [""],
        pagoCuenta: [""],
        pagoTarjeta: [""],
        pagoClabe: [""],
        mostrarPrecioLista: [false],
        precioListaDesc: [""],
        mostrarImgPlatillo: [false],
        mostrarImgEjercicio: [false],
        // tipoMensajes: ["", Validators.required],
        // CHECKBOX WITH AN ARRAY OF CHECKBOXES THAT AT LEAST ONE MUST BE CHECKED
        seccionesCuestionario: this.fb.array([], [Validators.required]),
      },
      //{validators: this.alMenosUnoValidator(['pagoCuenta', 'pagoTarjeta', 'pagoClabe'])}
    )
  }

  alMenosUnoValidator(campos: string[]): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const esValido = campos.some(campo => !!formGroup.get(campo)?.value?.trim());
      return esValido ? null : { alMenosUno: true };
    };
  }

  ngOnInit(): void {
    $('#sidebar-overlay').click();
    this.userInfo = JSON.parse(localStorage.getItem('userData'));
    this.getProgramas();
    this.getEntrenadores();
  }

  disabledBtnGuardar()
  {
    if(this.loading) return true;
    if(this.formPrograma.get('planEjercicios')?.value == false && this.formPrograma.get('planAlimentacion')?.value == false)
    {
      return true;
    }
    if(this.formPrograma.invalid) 
    {
      if(this.editing) {
        const camposDeshabilitados = ['entrenador', 'planAlimentacion', 'planEjercicios', 'cantPeriodos', 'cantSemanas', 'asesoria'];
        const sonValidosDeshabilitados = camposDeshabilitados.every(campo => {
          const control = this.formPrograma.get(campo);
          // Un control deshabilitado se considera válido, o si tiene un valor
          return control?.disabled || !!control?.value?.toString().trim();
        });
        if (!sonValidosDeshabilitados) return true;
      } else return true;
    }
    return false;
  }
  
  submitFormPrograma() {
    let imagen: any = null;
    if(this.croppedImage != null && this.rawFile != null) {
      let nombre = this.rawFile.name;
      let tipo = this.rawFile.type;
      let croppedImage = this.croppedImage.replace(/^data:.+;base64,/, '')
      this.uploadService.uploadImage(environment.businessId, this.utilsService.create_UUID(), nombre, croppedImage, tipo).subscribe({
        next: (fileData: any) => {
          imagen = { url: fileData.fileName, nombre: nombre};
          if(this.editing) this.updatePrograma(imagen);
          if(!this.editing) this.createPrograma(imagen);
        },
        error: (error) => {
          console.error(error)
        }
      })
    }
    else {
      if(this.previewUrl == null) imagen = null;
      if(this.editing) this.updatePrograma(imagen);
      if(!this.editing) this.createPrograma(imagen);
    }
  }
  createPrograma(imagen) {
    this.loading = true;

    let modelPrograma = {
      documentContainerId: this.userData.documentContainerId,
      nombre: this.formPrograma.get("nombre").value,
      tipo: this.formPrograma.get("tipo").value,
      opcional: this.formPrograma.get("opcional").value,
      entrenador: this.formPrograma.get("entrenador").value,
      descCorta: this.formPrograma.get("descCorta").value,
      descLarga: this.formPrograma.get("descLarga").value,
      cantPeriodos: Number(this.formPrograma.get("cantPeriodos").value),
      periodos: Array(Number(this.formPrograma.get("cantPeriodos").value)).fill({}),
      cantSemanas: Number(this.formPrograma.get("cantSemanas").value),
      planEjercicios: this.formPrograma.get("planEjercicios").value,
      planAlimentacion: this.formPrograma.get("planAlimentacion").value,
      precioFinal: Number(this.formPrograma.get("precioFinal").value),
      asesoria: this.formPrograma.get("asesoria").value,
      equipoGeneral: this.formPrograma.get("equipoGeneral").value,
      equipoEspecifico: this.formPrograma.get("equipoEspecifico").value,
      pagoNombre: this.formPrograma.get("pagoNombre").value,
      pagoBanco: this.formPrograma.get("pagoBanco").value,
      pagoCuenta: this.formPrograma.get("pagoCuenta").value,
      pagoTarjeta: this.formPrograma.get("pagoTarjeta").value,
      pagoClabe: this.formPrograma.get("pagoClabe").value,
      mostrarPrecioLista: this.formPrograma.get("mostrarPrecioLista").value,
      precioListaDesc: Number(this.formPrograma.get("precioListaDesc").value),
      mostrarImgPlatillo: this.formPrograma.get("mostrarImgPlatillo").value,
      mostrarImgEjercicio: this.formPrograma.get("mostrarImgEjercicio").value,
      // tipoMensajes: this.formPrograma.get("tipoMensajes").value,
      seccionesCuestionario: this.formPrograma.get("seccionesCuestionario").value,
      imagen: imagen,
      activo: true
    }

    console.log(modelPrograma)

    this.documentService.createDocumentInContainer(
      environment.businessId,
      this.userData.documentContainerId,
      null,
      "programa",
      null,
      modelPrograma
    ).subscribe({
      next: (data: any) => {
        console.log(data);
        // APPEND NEW PROGRAM TO LIST
        // this.listaProgramas.push(data);
        this.getProgramas();
        $("#modal-nuevoPrograma").modal("hide");
      },
      error: (error) => {
        // REMOVE PROGRAM FROM LIST
        this.listaProgramas.pop();
        console.log(error);
      },
      complete: () => {
        this.loading = false;
      }
    })
    
  }

  updatePrograma(imagen) {
    this.formPrograma.value.imagen = imagen;
    if(imagen == null){
      this.formPrograma.value.imagen = this.selectedProgram.imagen
    }

    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userData.documentContainerId,
      this.selectedProgram.documentId,
      "programa",
      null,
      this.formPrograma.value
    ).subscribe({
      next: (data: any) => {
        console.log(data);
        $("#modal-nuevoPrograma").modal("hide");
        this.inicializarFormPrograma();
        //UPDATE PROGRAM IN LIST
        this.listaProgramas.forEach((programa: any) => {
          if (programa.documentId == this.selectedProgram.documentId) {
            programa = data;
          }
        })
        this.getProgramas();
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        Swal.fire(
          "¡Listo!",
          "El programa ha sido actualizado.",
          "success"
        )
      }
    })
  }

  getEntrenadores(){
    this.loading = true;

    this.documentService.getDocumentsByType(
      environment.businessId,
      this.userData.documentContainerId,
      "entrenador"
    ).subscribe({
      next: (data: any) => {
        this.entrenadores = data.content;
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  getProgramas() {
    this.loading = true;

    this.documentService.getDocumentsByType(
      environment.businessId,
      this.userData.documentContainerId,
      "programa"
    ).subscribe({
      next: (data: any) => {
        this.listaProgramas = data.content;
        this.inicializarDataTableProgramas();
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  toggleProgramStatus(programa: any) {
    this.loading = true;

    let modelPrograma = {
      activo: !programa.activo
    }

    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userData.documentContainerId,
      programa.documentId,
      "programa",
      null,
      modelPrograma
    ).subscribe({
      next: (data: any) => {
        console.log(data);
        programa.activo = !programa.activo;
        Swal.fire(
          "¡Listo!",
          "El programa ha sido actualizado.",
          "success"
        )
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  modalEditarPrograma(programa: any) {
    setTimeout(() => {
      document.getElementById('tabs-config-tab')?.click();
    }, 0);
    this.editing = true;
    this.selectedProgram = programa;

    this.formPrograma.controls['entrenador'].disable();
    this.formPrograma.controls['planAlimentacion'].disable();
    this.formPrograma.controls['planEjercicios'].disable();
    this.formPrograma.controls['cantPeriodos'].disable();
    this.formPrograma.controls['cantSemanas'].disable();
    this.formPrograma.controls['asesoria'].disable();
    this.formPrograma.controls['tipo'].disable();

    $("#modal-nuevoPrograma").modal({ backdrop: "static", keyboard: false });
    $("#modal-nuevoPrograma").modal("show");

    // PATCH FORM WITH PROGRAM DATA
    this.formPrograma.patchValue({
      nombre: programa.nombre,
      tipo: programa.tipo,
      opcional: programa.opcional,
      entrenador: programa.entrenador,
      descCorta: programa.descCorta,
      descLarga: programa.descLarga,
      cantPeriodos: programa.cantPeriodos,
      cantSemanas: programa.cantSemanas,
      planEjercicios: programa.planEjercicios,
      planAlimentacion: programa.planAlimentacion,
      precioFinal: programa.precioFinal,
      asesoria: programa.asesoria,
      pagoNombre: programa.pagoNombre,
      pagoBanco: programa.pagoBanco,
      pagoCuenta: programa.pagoCuenta,
      pagoTarjeta: programa.pagoTarjeta,
      pagoClabe: programa.pagoClabe,
      mostrarPrecioLista: programa.mostrarPrecioLista,
      precioListaDesc: programa.precioListaDesc,
      mostrarImgPlatillo: programa.mostrarImgPlatillo,
      mostrarImgEjercicio: programa.mostrarImgEjercicio,
      // tipoMensajes: programa.tipoMensajes,
    })
    if(programa.imagen) this.previewUrl = programa.imagen.url;
    this.setFormArrays(programa.seccionesCuestionario, 'seccionesCuestionario');
    this.setFormArrays(programa.equipoGeneral, 'equipoGeneral');
    this.setFormArrays(programa.equipoEspecifico, 'equipoEspecifico');
  }
  setFormArrays(array, controlName: string)
  {
    const formArray = this.formPrograma.get(controlName) as FormArray;
    formArray.clear(); // Limpiar el array antes de agregar nuevas secciones
    array.forEach((item: string) => {
      formArray.push(this.fb.control(item)); // Agregar cada sección como un FormControl
    });
  }

  filterPrograms() {

    const filters: any = {
      "documentContainerId": this.userInfo.documentContainerId,
      // "empresaId": this.userInfo.empresaId,
      // "activo": true
    };
    // GET FILTERS ARRAY
    let query: any = this.documentService.getFiltersArray(filters);
    if(this.filters.tipo != '') {
      query.push({
        "match_phrase": {
          "tipo.keyword": this.filters.tipo
        }
      });
    }
    if(this.filters.entrenador != '') {
      query.push({
        "match_phrase": {
          "entrenador.keyword": this.filters.entrenador
        }
      });
    }
    console.log(query);

    const esQuery = {
      "from": 0,
      "size": 1000,
      // "sort": {
      //   "routeDate.keyword": {
      //     "order": "desc"
      //   }
      // },
      "query": {
        "bool": {
          "must": [],
          "filter": query,
          "should": [],
          "must_not": []
        }
      },
    }

    this.documentService.searchDocument(
      environment.businessId,
      "programa",
      esQuery
    ).subscribe({
      next: (data: any) => {
        this.listaProgramas = data;
        this.inicializarDataTableProgramas();
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }
  dataTableProgramas: any;
  inicializarDataTableProgramas()
  {
    if (this.dataTableProgramas) {
      this.dataTableProgramas.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableProgramas = $('#dataTable-listaProgramas').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No se encontraron resultados"
        },
        pageLength: 10,
        
        columnDefs: [
          {
            targets: 7, // Índice de la columna que contiene los iconos
            type: 'num', // Tipo de ordenación (numérica)
          }
        ]
      });
    });
  }

  // IMAGES UTILS

  fileChangeEvent(event: any): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];

     
      const maxSize = .8 * 1024 * 1024;

      if (this.selectedFile.size > maxSize) {
        Swal.fire({
          icon: 'error',
          title: 'Imagen demasiado grande',
          text: `El tamaño máximo permitido es de 830KB.`,
        });

        // ❌ Restablece el input y cancela la carga
        this.errorFileType(true);
        return;
      }

      // Configurar el evento para el cropper
      this.imageChangedEvent = event;
      this.bolCroppedImg = true;

      // Almacenar detalles del archivo
      const reader = new FileReader();
      reader.onload = () => {
        this.rawFile = {
          file: reader.result,
          type: this.selectedFile?.type,
          name: this.selectedFile?.name
        };
        console.log('Raw File:', this.rawFile);
      };
      reader.readAsBinaryString(this.selectedFile);
    }
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64; // Imagen recortada en base64
    // console.log('Cropped Image:', this.croppedImage);
  }
  imageLoaded() {
    console.log('Image loaded');
  }
  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
  }
  loadImageFailed() {
    console.error('Failed to load image');
    this.errorFileType(true);
  }
  deleteImage() {
    this.errorFileType(false);
  }
  errorFileType(alert: boolean) {
    this.croppedImage = '';
    this.imageChangedEvent = '';
    this.bolCroppedImg = false;
    this.selectedFile = null;
    this.previewUrl = null;
    this.rawFile = null;
    if (alert) {
      console.error('Invalid file type. Please select an image.');
    }
  }

  // FORM UTILS

  onCheckboxChange(event: any, controlName: string) {
    const checkbox = event.target as HTMLInputElement;
    const formArray = this.formPrograma.get(controlName) as FormArray;

    if (checkbox.checked) {
      // Agregar si no está presente
      formArray.push(this.fb.control(checkbox.value));
    } else {
      // Remover si está presente
      const index = formArray.controls.findIndex(ctrl => ctrl.value === checkbox.value);
      if (index !== -1) {
        formArray.removeAt(index);
      }
    }
  }

  // UTILS

  modalNuevoPrograma() {
    $('#modal-nuevoPrograma').on('show.bs.modal', function (event) {
      $(this).find('.nav a:first').tab('show');
    })
    this.inicializarFormPrograma();

    setTimeout(() => {
      document.getElementById('tabs-config-tab')?.click();
    }, 0);

    $("#modal-nuevoPrograma").modal({ backdrop: "static", keyboard: false });
    $("#modal-nuevoPrograma").modal("show");

    this.formPrograma.controls['tipo'].enable();
    this.formPrograma.controls['entrenador'].enable();
    this.formPrograma.controls['planAlimentacion'].enable();
    this.formPrograma.controls['planEjercicios'].enable();
    this.formPrograma.controls['cantPeriodos'].enable();
    this.formPrograma.controls['cantSemanas'].enable();
    this.formPrograma.controls['asesoria'].enable();

  }

  inicializarFormPrograma()
  {
    this.editing = false;
    this.errorFileType(false);

    const equipoEspecifico = this.formPrograma.get('equipoEspecifico') as FormArray;
    equipoEspecifico.clear(); 
    const seccionesCuestionario = this.formPrograma.get('seccionesCuestionario') as FormArray;
    seccionesCuestionario.clear(); 
    const equipoGeneral = this.formPrograma.get('equipoGeneral') as FormArray;
    equipoGeneral.clear(); 
    
    this.formPrograma.setValue({
      nombre: "",
      tipo: "",
      opcional: "",
      entrenador: "",
      descCorta: "",
      descLarga: "",
      cantPeriodos: "0",
      cantSemanas: "0",
      planEjercicios: false,
      planAlimentacion: false,
      precioFinal: "",
      asesoria: false,
      // CHECKBOX WITH AN ARRAY OF CHECKBOXES THAT AT LEAST ONE MUST BE CHECKED
      equipoGeneral: [],
      equipoEspecifico: [],
      pagoNombre: "",
      pagoBanco: "",
      pagoCuenta: "",
      pagoTarjeta: "",
      pagoClabe: "",
      mostrarPrecioLista: false,
      precioListaDesc: "",
      mostrarImgPlatillo: false,
      mostrarImgEjercicio: false,
      // tipoMensajes: "",
      // CHECKBOX WITH AN ARRAY OF CHECKBOXES THAT AT LEAST ONE MUST BE CHECKED
      seccionesCuestionario: [],
    })
  }
}
